import { StoryNodeOptions } from "../../storyV2/domain/StoryNodeOptions";
import { StudioProjectAttributesV3Node } from "../../project/domain/StudioProjectAttributesV3Node";
import { StudioProjectAttributesV3NodeData } from "../../project/domain/StudioProjectAttributesV3NodeData";
import isBlank from "@sedan-utils/is-blank";
class StoryNodeOptionsUtil {
    static from(params, isFromUIData) {
        if (!(params.data instanceof StudioProjectAttributesV3NodeData)) {
            throw new Error("node data type is wrong");
        }
        const type = StoryNodeOptions.getNodeType(params.type ?? "");
        const displayType = StoryNodeOptions.getDisplayTypeType(params.data.displayType ?? "");
        const parentId = params.data.parentNodeId;
        let content;
        if (typeof params.data.textAreaValue === "object") {
            params.data.textAreaValue.fromUIData = isFromUIData;
            const jsonStr = JSON.stringify(params.data.textAreaValue);
            content = jsonStr;
        }
        else {
            content = params.data.textAreaValue;
        }
        return new StoryNodeOptions(params.id, content, type, displayType, parentId, params.data.childNode ?? [], params.data.inputTitle || "", params.data.generatedLabel || "");
    }
    static optionsToProjectNode(options, content) {
        const nodeData = new StudioProjectAttributesV3NodeData();
        nodeData.parentNodeId = options.parentId;
        nodeData.childNode = options.children;
        nodeData.inputTitle = options.inputTitle;
        nodeData.generatedLabel = options.generatedLabel;
        nodeData.displayType = options.displayType;
        nodeData.textAreaValue = content;
        const node = new StudioProjectAttributesV3Node();
        node.id = options.id;
        node.type = options.type;
        node.parentNode = options.parentId;
        node.data = nodeData;
        if (!isBlank(options.parentId)) {
            node.extent = "parent";
        }
        return node;
    }
}
export default StoryNodeOptionsUtil;
